<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
    <section class="sm:pt-24 relative overflow-x-clip">
        <NuxtImg src="/images/my-story/my-story-bg-top-mobile.svg" alt="Top background" class="md:hidden w-full h-auto -mb-[1px]" />
        <NuxtImg src="/images/my-story/my-story-bg-top.svg" alt="Top background" class="hidden md:block w-full h-auto -mb-[1px]" />
        <div class="bg-[#EDFAF2] py-12">
            <UContainer>
                <div class="grid grid-cols-2 gap-12 sm:gap-24 max-w-[1000px] mx-auto items-center justify-around">
                    <div class="col-span-2 sm:col-span-1">
                        <NuxtImg src="/images/my-story/barbara.webp" alt="Barbara Bernot" class="w-full" preload fetchpriority="high" />
                    </div>
                    <div class="col-span-2 sm:col-span-1 flex flex-col gap-4.5">
                        <p class="mb-4 text-[#032E14]" v-html="t('myStory.description_1')"></p>
                        <p class="mb-4 text-[#032E14]" v-html="t('myStory.description_2')"></p>
                        <p class="text-[#032E14]" v-html="t('myStory.description_3')"></p>
                    </div>
                    <div class="col-span-2 relative max-w-[800px] mx-auto">
                        <div class="my-story-text-cloud-top bg-[#ffffff] flex justify-center items-center py-4 px-8 lg:px-24 w-full">
                            <p class="text-center font-bold text-[#32734F] text-[14px] leading-[21px] sm:text-[26px] sm:leading-[36px]">{{ t("myStory.cloud") }}</p>
                        </div>
                        <NuxtImg src="/images/my-story/text-illustration-2.svg" alt="Illustracija" class="hidden lg:block w-[300px] h-auto absolute top-[40%] right-[90%]" />
                        <NuxtImg src="/images/my-story/text-illustration-3.svg" alt="Illustracija" class="lg:hidden w-[50px] h-auto absolute top-[70%] right-[87%]" />
                    </div>
                    <div class="col-span-2 flex justify-center items-center max-w-[500px] mx-auto">
                        <p class="text-[#032E14] text-start sm:text-center" v-html="t('myStory.quote')"></p>
                    </div>
                </div>
            </UContainer>
        </div>
        <NuxtImg src="/images/my-story/text-illustration-1.svg" alt="Illustracija" class="w-[150px] md:w-[200px] lg:w-[300px] h-auto absolute -top-6 lg:top-12 -right-[50px] lg:right-0" />
        <NuxtImg src="/images/my-story/text-illustration-4.svg" alt="Illustracija" class="hidden lg:block w-[160px] h-auto absolute bottom-70 right-0" />
        <svg width="0" height="0" style="position:absolute">
            <defs>
                <clipPath id="my-story-texts-bg-cloud-top" clipPathUnits="objectBoundingBox">
                    <path d="M0.0786 0 L0.9207 0 C0.9683 0 1 0.1465 0.9986 0.311 L0.981 0.7625 C0.9755 0.8985 0.9429 1 0.9036 1 L0.1187 1 C0.0843 1 0.0539 0.9213 0.0437 0.8075 L0.0036 0.3555 C-0.0121 0.1791 0.0256 0 0.0786 0 Z" />
                </clipPath>
            </defs>
        </svg>
        <div class="w-full pb-50 sm:pb-60 bg-[#EDFAF2]"></div>
    </section>
</template>

<style scoped>
.my-story-text-cloud-top {
    aspect-ratio: 3;
    clip-path: url(#my-story-texts-bg-cloud-top);
}
</style>
